<template>
  <ul class="ulReset">
    <li v-for="(stockInfo, index) in stockInfosDisplay" :key="stockInfo.store.id" :class="[$style.stockInfoItem, {[$style.stockInfoItemLast]: index === stockInfos.length -1}]">
      <div :class="$style.stockInfoHeader">
        <h3 :class="$style.stockInfoHeaderName">
          {{ stockInfo.store.name }}
        </h3>
        <div :class="$style.stockInfoHeaderAddress">
          <lv-button
            styling="link-primary-version2"
            :class="$style.stockInfoHeaderAddressLink"
            :href="stockInfo.mapsUrl"
            target="_blank"
          >
            {{ stockInfo.addressText }}
          </lv-button>
        </div>
        <div :class="$style.stockInfoHeaderPhoneNumber">
          {{ $awt('aw.common.product.informations.accordion.product_stock_info.tel', { phone_number: stockInfo.store.phoneNumber }) }}
        </div>
      </div>
      <div :class="[$style.stockInfoDetail]">
        <div :class="$style.stockInfoDetailRow">
          <div :class="$style.stockInfoDetailRowText">
            <lv-icon :size="16" name="store-16" style="vertical-align: unset;" />
            <span>{{ $awt('aw.common.product.stock_information.dealer.store_stock') }}</span>
          </div>
          <div :class="$style.stockInfoDetailRowValue">
            {{ stockInfo.store.stock }} {{ $awt('aw.global.quantity.piece') }}
          </div>
        </div>
        <div :class="$style.stockInfoDetailRow">
          <div :class="$style.stockInfoDetailRowText">
            <lv-icon :size="16" name="full-screen-16" style="vertical-align: unset;" />
            <span>{{ $awt('aw.common.product.stock_information.dealer.logistic_stock') }}</span>
          </div>
          <div :class="$style.stockInfoDetailRowValue">
            {{ stockInfo.logistic.stock }} {{ $awt('aw.global.quantity.piece') }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
  import { computed } from 'vue';
  import { LvIcon, LvButton } from '~~/common/components/loginet-vue-shop/index';
  import { createStockInfosList } from '~~/common/utils/stockInfoDisplay';

  const props = defineProps({
    stockInfos: {
      type: Array,
      default: () => [],
    },
  });

  const stockInfosDisplay = computed(() => {
    return createStockInfosList(props.stockInfos);
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.stockInfo {
  &Header {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-template-areas: "name phoneNumber" "address phoneNumber";
    margin-bottom: 16px;

    &Name {
      font-size: 14px;
      font-weight: $font-weight-bold-v2;
      line-height: 20px;
      grid-area: name;
    }

    &Address {
      grid-area: address;
      line-height: 16px;

      &Link {
        font-size: 12px;
        font-weight: $font-weight-medium-v2;
        line-height: 16px;
        width: auto;
        padding: 0;
        text-align: left;
        text-decoration: underline;
      }
    }

    &PhoneNumber {
      font-size: 12px;
      font-weight: $font-weight-regular-v2;
      line-height: 16px;
      display: flex;
      justify-content: flex-end;
      color: $color-text-secondary;
      grid-area: phoneNumber;
    }
  }

  &Item {
    margin-top: 16px;
    padding-bottom: 8px;
    border-bottom: 1px dashed $color-dash-separator;

    &Last {
      border-bottom: none;
    }
  }

  &Detail {
    font-size: 12px;
    line-height: 16px;
    border-radius: 12px;

    &Row {
      display: grid;
      width: 100%;
      margin-bottom: 8px;
      grid-template-columns: 1fr 1fr;

      &Text {
        font-weight: $font-weight-bold-v2;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      &Value {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
</style>
